import React from 'react';
import { TbAlertSquareRounded, TbShoppingBagSearch, TbFileInvoice, TbZoom } from 'react-icons/tb';
import ButtonPrimary from '../Form/ButtonPrimary';
import { sanitizeText } from '../../Utils/Helpers';

export const CONFIRM_ICON_SEARCH = 'search';
export const CONFIRM_ICON_SEARCH_BAG = 'searchBag';
export const CONFIRM_ICON_INVOICE = 'invoice';

interface ConfirmProps {
    onConfirm: CallableFunction;
    onCancel: CallableFunction;
    title: string;
    message?: any;
    labelConfirm?: string;
    labelCancel?: string;
    icon?: string;
  }

  const Confirm = ({
    onConfirm = () => {},
    onCancel = () => {},
    title,
    message,
    labelConfirm = "Sim",
    labelCancel = "Cancelar",
    icon
  }: ConfirmProps) => {

    const iconMap: any = {
      [CONFIRM_ICON_SEARCH]: TbZoom,
      [CONFIRM_ICON_SEARCH_BAG]: TbShoppingBagSearch,
      [CONFIRM_ICON_INVOICE]: TbFileInvoice,
    };

    const IconComponent = icon ? iconMap[icon] : TbAlertSquareRounded;

    return (
      <section className='flex flex-col items-center w-full p-6 gap-8'>
        <h4 className='flex flex-col items-center'>
            <span className='mb-2'>
              <IconComponent size={55} className="text-shopfood-alert zoomInIcon" />
            </span>
            <span className='font-extrabold text-2xl text-gray-700 mb-2 leading-6'>{ title }</span>
            {message && <span className='leading-5' dangerouslySetInnerHTML={{ __html: sanitizeText(message) }}></span>}
        </h4>

        <div className='flex justify-center gap-2 w-full text-sm'>
            <ButtonPrimary onClick={() => onConfirm()}>{ labelConfirm }</ButtonPrimary>
            <ButtonPrimary outline onClick={() => onCancel()}>{ labelCancel }</ButtonPrimary>
        </div>
      </section>
    );
}

export default Confirm;
